import React, { memo, useEffect, useMemo } from 'react'
import { synapse } from 'state'

import { masterHeaderHeightSetter } from 'utils/table/wrapText'

import HeaderCellCheckbox from './components/HeaderCellCheckbox'
import HeaderCellField from './components/HeaderCellField'
import HeaderCellMenu from './components/HeaderCellMenu'

const AbstractAgGridCustomHeader = ({
  // AG Grid default props for framework components
  api,
  column,
  setSort,
  displayName,
  enableSorting,
  showColumnMenu,
  // "abstract" props
  selection,
  detailsSelection,
  onChangeSelectAllCallback
}) => {
  const {
    colDef: { detailField = null }
  } = column
  const { context } = api.gridOptionsWrapper.gridOptions

  // Select all is always shown if the table is not the details one
  // If the header is in the details table, it's been shown iff is in editing mode
  const showSelectAll = useMemo(
    () => (!detailField ? true : detailField && context?.editing),
    [context, detailField, selection]
  )

  useEffect(() => {
    const unsubscribe = synapse.subscribe('columnResized', () => {
      masterHeaderHeightSetter(api)
    })
    return () => {
      unsubscribe()
    }
  }, [])

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {showSelectAll && (
        <HeaderCellCheckbox
          api={api}
          column={column}
          selection={selection}
          detailsSelection={detailsSelection}
          onChangeSelectAllCallback={onChangeSelectAllCallback}
        />
      )}
      <HeaderCellField
        column={column}
        displayName={displayName}
        enableSorting={enableSorting}
        setSort={setSort}
      />
      {column.menuVisible && <HeaderCellMenu showColumnMenu={showColumnMenu} />}
    </div>
  )
}

export default memo(AbstractAgGridCustomHeader)
